import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MaterialUniqueService = {
    getById: async (id) => axios.get(`${API_URL}/material-unique/${id}`).then(({data}) => data).catch((err) => { throw err }),
}

export default MaterialUniqueService;